import axios from "axios";
import ReusableTable from "../ReusableTable/ReusableTable";
import classes from "./SLIPTAchecklist.module.css";
import { env } from "../../constants/env";
import { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { db } from "../../utils/offlineDB";

const SLIPTAchecklist = () => {
  const { user, token } = useAuth();
  const [labData, setLabData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const sliptaColumns = [
    { label: "Date & Time Entered", field: "dateTime" },
    { label: "Laboratory Name", field: "labName" },
    { label: "HPCZ License Number", field: "license" },
    { label: "Physical Address", field: "address" },
    { label: "Facility Phone", field: "phone" },
    { label: "Facility Email", field: "email" },
  ];

  useEffect(() => {
  const fetchLabs = async () => {
    setLoading(true);
    try {
      // 1️⃣ Load from IndexedDB
      let localLabs = await db.offlineLabs.toArray();

      // Filter for ASSESSOR only
      if (user.role === "ASSESSOR") {
        localLabs = localLabs.filter((lab) =>
          user.accessibleLabs?.includes(lab.id)
        );
      }

      // Offline case
      if (!navigator.onLine) {
        if (localLabs.length > 0) {
          const formattedLocal = localLabs.map((lab) => ({
            dateTime: new Date(lab.createdAt || lab.timestamp).toLocaleString(),
            labName: lab.labName,
            license: lab.hpczLicense,
            address: lab.physicalAddress || "",
            phone: lab.telephone,
            email: lab.email,
            id: lab.id,
          }));
          setLabData(formattedLocal);
        } else {
          setError("No offline data available for your accessible labs");
        }
        setLoading(false);
        return;
      }

      // 2️⃣ Online: fetch from API
      let serverLabs = (await axios.get(`${env.kataApiUrl}/api/labs`, {
        headers: { Authorization: `Bearer ${token}` },
      })).data;

      // Filter for ASSESSOR only
      if (user.role === "ASSESSOR") {
        serverLabs = serverLabs.filter((lab) =>
          user.accessibleLabs?.includes(lab._id)
        );
      }

      const formatted = serverLabs.map((lab) => ({
        dateTime: new Date(lab.createdAt).toLocaleString(),
        labName: lab.labName,
        license: lab.hpczLicense,
        address: lab.physicalAddress || "",
        phone: lab.telephone,
        email: lab.email,
        id: lab._id,
      }));

      setLabData(formatted);

      // Save/update IndexedDB
      const savePromises = serverLabs.map((lab) =>
        db.offlineLabs.put({
          ...lab,
          id: lab._id,
          offline: false,
          lastSynced: new Date().toISOString(),
          timestamp: Date.now(),
        })
      );
      await Promise.all(savePromises);
    } catch (err) {
      console.error("Error fetching SLIPTA labs:", err);
      if (!labData.length) setError("Failed to fetch SLIPTA labs");
    } finally {
      setLoading(false);
    }
  };

  fetchLabs();
}, [token, user.role, user.accessibleLabs]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;
  if (!labData || labData.length === 0) return <p>No SLIPTA labs found</p>;

  return (
    <div className={classes.wrapper}>
      <ReusableTable
        title="SLIPTA Checklist"
        columns={sliptaColumns}
        data={labData}
        accreditationName="slipta"
      />
    </div>
  );
};

export default SLIPTAchecklist;